export default __webpack_public_path__ + "a0acecc82b2bf1be0db1d1b5e4d08a04.png";